export const restDefaultHandlers = {
  onError(res?: { status: number; data?: { [key: string]: string | boolean } }): void {
    if (!res) {
      return;
    }

    if (res.status === 403 && res.data?.forbidden_for_demo_account) {
      window.dispatchEvent(new CustomEvent('demo-account-forbidden'));
      return;
    }

    if (res.status === 403 || res.status === 404) {
      window.dispatchEvent(new CustomEvent('forbidden-notfound'));
      return;
    }

    if (res.status === 413) {
      const event = new CustomEvent('hjNotification', {
        detail: {
          cls: 'notification-box-error',
          message: 'The uploaded data is too large.',
          timeout: 6000,
        },
      });

      window.dispatchEvent(event);
      return;
    }

    if (res.status === 503) {
      if (res.data && !!res.data.maintenance) {
        const event = new CustomEvent('hjNotification', {
          detail: {
            cls: 'notification-box-error',
            message: `This action is temporarily unavailable as we’re performing some minor
              maintenance operations. Please try again later.`,
            timeout: 6000,
          },
        });

        window.dispatchEvent(event);
      } else {
        window.dispatchEvent(new CustomEvent('feature-maintenance-mode'));
      }
    }
  },
};
